"use client";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import { Accordion } from "@/components/ui/accordion";
import { FilterNav } from "@/components";
import { useEffect, useState } from "react";
import useStore from "@/lib/state";

export function EventsFilterDrawer({ categories, locations, types }) {
  const {
    activeCategories,
    setActiveCategories,
    activeTypes,
    setActiveTypes,
    activeLocations,
    setActiveLocations,
  } = useStore();

  const { setSearchTerm } = useStore();
  const [searchWord, setSearchWord] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (searchWord == "") setSearchTerm("");
  }, [searchWord, setSearchTerm]);

  function handleSubmit(e) {
    e.preventDefault();
    setSearchTerm(searchWord);
    setOpen(false);
  }

  function clearAllFilters() {
    setActiveCategories([]);
    setActiveTypes([]);
    setActiveLocations([]);
    setSearchWord("");
    setSearchTerm("");
  }

  const activeFilterCount =
    activeCategories.length + activeTypes.length + activeLocations.length;

  const sectionCount = [categories, types, locations].filter(
    (items) => items?.length > 0
  ).length;
  const singleSection = sectionCount <= 1;

  const filters = (
    <>
      <FilterNav
        filterName="Categories"
        items={categories}
        setActiveItems={setActiveCategories}
        activeItems={activeCategories}
        asCheckbox
        alwaysOpen={singleSection}
        containOpen={!singleSection}
      />
      <FilterNav
        filterName="Types"
        items={types}
        setActiveItems={setActiveTypes}
        activeItems={activeTypes}
        asCheckbox
        alwaysOpen={singleSection}
        containOpen={!singleSection}
      />
      <FilterNav
        filterName="Locations"
        items={locations}
        setActiveItems={setActiveLocations}
        activeItems={activeLocations}
        asCheckbox
        alwaysOpen={singleSection}
        containOpen={!singleSection}
      />
    </>
  );

  return (
    <Drawer
      direction="bottom"
      open={open}
      onOpenChange={setOpen}
      shouldScaleBackground={false}
    >
      <DrawerTrigger className="lg:hidden" asChild>
        <Button size="lg" variant="outline">
          Filter {activeFilterCount > 0 ? `(${activeFilterCount})` : ""}
        </Button>
      </DrawerTrigger>
      <DrawerContent className="h-[80vh] px-4 py-4">
        <div
          className="flex flex-col h-full min-h-0 p-4 space-y-4 overflow-hidden"
          style={{
            // Match desktop What’s On filter column (red gum accents)
            "--button-background": "137 33 2",
            "--button-hover-background": "137 33 2",
            "--button-foreground": "255 255 255",
          }}
        >
          <form onSubmit={handleSubmit} className="flex w-full shrink-0">
            <input
              className="h-11 w-full rounded-l-full border-2 border-brand-fawn bg-white pl-3 pr-6 text-base focus:outline-none"
              onChange={(e) => setSearchWord(e.target.value)}
              placeholder="Search..."
              value={searchWord}
              type="text"
            />
            <button
              className="px-4 text-base font-button font-semibold rounded-r-full h-11 bg-button text-button-foreground"
              type="submit"
            >
              Search
            </button>
          </form>
          {singleSection ? (
            <div className="flex flex-col w-full min-h-0 flex-1 overflow-hidden">
              {filters}
            </div>
          ) : (
            <Accordion
              type="single"
              collapsible
              className="flex flex-col w-full min-h-0 flex-1 overflow-hidden"
            >
              {filters}
            </Accordion>
          )}
          <div className="grid shrink-0 grid-cols-2 gap-3 border-t-2 border-brand-fawn pt-4">
            <Button variant="outline" onClick={clearAllFilters}>
              Clear all filters
            </Button>
            <Button onClick={() => setOpen(false)}>Show results</Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
